export const GET_CHECK_URL = '/utility/check-url';
